import { MENU_COUNTER_HOOKS, type MenuCounter } from '../composition/shell'

export type { MenuCounter }

/**
 * Счётчики пунктов левого меню по id раздела. Оболочка вида ресурса не знает: какие данные считает счётчик — решает вклад вида
 * в реестре `composition/shell` (RP-FB35: «Чеки» → «требуют внимания» и «отложенные»).
 */
export function useMenuCounters(): Readonly<Record<string, readonly MenuCounter[]>> {
  const merged: Record<string, MenuCounter[]> = {}
  for (const useCounters of MENU_COUNTER_HOOKS) {
    // Список вкладов постоянный: хуки вызываются в одном и том же порядке на каждом рендере.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    for (const [section, counters] of Object.entries(useCounters())) merged[section] = [...(merged[section] ?? []), ...counters]
  }
  return merged
}
